import { React, useState, useRef } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from '../../axios';

export default function ResetPasswordStepTwo({changeStep, userEmail}) {
    const [validated, setValidated] = useState(false);
    const [isSubmitting, setIsSumitting] = useState(false);
    const [number, setNumber] = useState({
        digit1: '',
        digit2: '',
        digit3: '',
        digit4: ''
    });
    let inputRef = useRef(null);

    const handleNumber = (event) => {
        const result = event.target.value.replace(/[^0-9]/, '');
        setNumber({
            ...number,
            [event.target.name]: result
        });

        const { maxLength, value, name } = event.target;
        const fieldIndex = name.slice(-1);
        // Check if they hit the max character length
        if (value.length >= maxLength) {
            // Check if it's not the last input field
            if (parseInt(fieldIndex, 10) < 4) {
            // Get the next input field
            const nextSibling = document.querySelector(
                `input[name=digit${parseInt(fieldIndex, 10) + 1}]`
            );

            // If found, focus the next field
            if (nextSibling !== null) {
                nextSibling.focus();
            }
            }
        }
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        else{
            event.preventDefault();
            event.stopPropagation();
            setIsSumitting(true);
            let otpCode = (event.target.digit1.value).toString();
            otpCode += (event.target.digit2.value).toString();
            otpCode += (event.target.digit3.value).toString();
            otpCode += (event.target.digit4.value).toString();
            var formObj = {
                otpCode: parseInt(otpCode),
                email: userEmail
            };

            axios.post('/confirm-otp', formObj)
            .then((response) => {
                if (response.data) {
                    if (response.status === 200) {
                        toast.success(response.data.message);
                        changeStep(response.data.email);
                    } else {
                        toast.warn('No response from server');
                    }
                }
                setIsSumitting(false);
            })
            .catch((error) => {
                if (error.response?.status === 422) {
                    toast.error(error.response.data.message);
                } else if (error.response?.data?.otpCode) {
                    toast.error('OTP Code is invalid');
                } else {
                    toast.error('Something went wrong');
                }
                setIsSumitting(false);
            })
        }
    
        setValidated(true);
    };
  return (
    <div className='pass-reset-step2'>
        <h2 className='mb-3'>Verify OTP</h2>
        <p>We sent the code to your email to verify it's really you. The code will expire in next 20 minutes.</p>
        <p className='fw-bold'>Enter the 4 digits code</p>
        <Form className='forms otp-form' noValidate validated={validated} onSubmit={handleSubmit}>
            <div className='row g-0 align-items-end'>
                <div className='col-lg-8 col-md-12'>
                    <div className='d-flex justify-content-between mb-4'>
                        <Form.Control required type="text" className='bg-light mb-4' name='digit1' value={number.digit1} 
                            maxLength={1} onChange={handleNumber}
                        />
                        <Form.Control required type="text" className='bg-light mb-4' name='digit2' value={number.digit2} 
                            maxLength={1} onChange={handleNumber}
                        />
                        <Form.Control required type="text" className='bg-light mb-4' name='digit3' value={number.digit3} 
                            maxLength={1} onChange={handleNumber}
                        />
                        <Form.Control required type="text" className='bg-light mb-4' name='digit4' value={number.digit4} 
                            maxLength={1} onChange={handleNumber}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter the code.
                        </Form.Control.Feedback>
                    </div>
                </div>
                <div className='col-lg-4 col-md-12'>
                    <Button type='submit' variant='primary' className='btn-full-width mb-5 ms-lg-3 ms-md-0' disabled={isSubmitting}>
                        Submit
                        {
                            isSubmitting &&
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className='ms-2'
                            />
                        }
                    </Button>
                </div>
            </div>
        </Form>
    </div>
  )
}
